import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, NotificationResponse } from "@/types";

export function useGetNotifications() {
  return useQuery({
    queryKey: ["notifications"],
    queryFn: async () => {
      const path = "notifications";
      const res = await guacHttpClient.get<
        NotificationResponse[],
        HttpResponse<NotificationResponse[]>
      >(path);

      return res.data;
    },
  });
}
